import React from 'react';
import { Link } from 'react-router-dom';
import Make from '../components/block/make';
import SingleBox from '../components/block/singleBox';
import FiltterList from '../components/block/filtterList';

/**
 * Landing Page - Public Access (No Login Required)
 * This is the main entry point for the frontend application.
 * The root path "/" displays this landing page.
 */
export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section - GIGM Style */}
      <div className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-gray-900 to-black">
        {/* Background image removed - can be added to public folder if needed */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
        <div className="relative h-[600px] md:h-[700px] flex items-center px-5 md:px-20">
          <div className="container mx-auto grid md:grid-cols-2 gap-8 items-center">
            <div className="text-center md:text-left space-y-6 z-10">
              <h1 className="font-display text-display text-white font-bold [text-shadow:_4px_4px_16px_rgb(0_0_0_/_100%),_0_0_20px_rgb(0_0_0_/_80%)]">
                The modern way to <span className="text-[#DC2626] [text-shadow:_3px_3px_12px_rgb(0_0_0_/_100%),_0_0_15px_rgb(0_0_0_/_80%)]">own your dream car</span>
              </h1>
              <p className="text-body-lg text-white max-w-2xl font-bold leading-relaxed [text-shadow:_3px_3px_12px_rgb(0_0_0_/_100%),_0_0_15px_rgb(0_0_0_/_80%)]">
                GIG Autos is an African technology-powered company, providing seamless automotive services to customers across Africa.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <a 
                  href="#search-fliter" 
                  className="px-8 py-3 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-semibold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  Browse Cars
                </a>
                <Link 
                  to="/cars" 
                  className="px-8 py-3 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold rounded-lg transition-all duration-300 border border-white/30"
                >
                  View All
                </Link>
              </div>
            </div>
            <div className="hidden md:block relative">
              <img 
                className="w-full h-auto object-contain drop-shadow-2xl animate-float" 
                src="/cars.png" 
                alt="Cars" 
              />
            </div>
          </div>
        </div>
      </div>

      {/* Make Section - Enhanced */}
      <div className="relative -mt-10 md:-mt-20 z-20">
        <div className="bg-white rounded-t-3xl">
          <div className="py-8">
            <Make />
          </div>
        </div>
      </div>

      {/* Filter Section - Enhanced */}
      <div id='search-fliter' className="py-12 px-4 md:px-20 bg-white">
        <FiltterList />
      </div>

      {/* Stats Section - GIGM Style */}
      <div className="relative overflow-hidden bg-[#E0F2FE] text-gray-900 py-16 md:py-20">
        <div className="relative container mx-auto px-5 md:px-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div className="flex flex-col md:flex-row justify-center items-center gap-6 p-6 bg-white rounded-xl hover:shadow-lg transition-all duration-300 border border-gray-100 shadow-sm">
              <div className="relative">
                <img 
                  src="/customer.png" 
                  alt="Happy Customers" 
                  className="w-20 h-20 md:w-28 md:h-28 object-contain" 
                />
              </div>
              <div className="text-center md:text-left">
                <h1 className="font-display text-4xl md:text-5xl font-bold text-[#DC2626] mb-2 tracking-tight">200k+</h1>
                <h2 className="text-heading-sm text-gray-700 font-medium">Happy Customers</h2>
              </div>
            </div>
            <div className="flex flex-col md:flex-row justify-center items-center gap-6 p-6 bg-white rounded-xl hover:shadow-lg transition-all duration-300 border border-gray-100 shadow-sm">
              <div className="relative">
                <img 
                  src="/mechanic.png" 
                  alt="Years of Experience" 
                  className="w-20 h-20 md:w-28 md:h-28 object-contain" 
                />
              </div>
              <div className="text-center md:text-left">
                <h1 className="font-display text-4xl md:text-5xl font-bold text-[#DC2626] mb-2 tracking-tight">10+</h1>
                <h2 className="text-heading-sm text-gray-700 font-medium">Years of Experience</h2>
              </div>
            </div>
            <div className="flex flex-col md:flex-row justify-center items-center gap-6 p-6 bg-white rounded-xl hover:shadow-lg transition-all duration-300 border border-gray-100 shadow-sm">
              <div className="relative">
                <img 
                  src="/support.png" 
                  alt="Customer Support" 
                  className="w-20 h-20 md:w-28 md:h-28 object-contain" 
                />
              </div>
              <div className="text-center md:text-left">
                <h1 className="font-display text-4xl md:text-5xl font-bold text-[#DC2626] mb-2 tracking-tight">24/7</h1>
                <h2 className="text-heading-sm text-gray-700 font-medium">Customer Support</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Vehicle Types & EMI Section - Enhanced */}
      <div className='py-12 md:py-16 px-4 md:px-20 bg-gray-50'>
        <SingleBox />
      </div>
    </div>
  );
}

